<template>
  <div>
    <div v-if="!shifKorigi">
      <label>{{ $t("Врач ID") }}</label>
        <div style="display: flex; height: 37px; justify-content: space-between;">
          <div style="width: calc(100% - 50px);">
              <!-- @input="direct" -->
            <v-select
              :filter="fuseSearch"
              id="naprovitel"
              :options="Naprovitel"
              :get-option-label="option => option.name"
              :reduce="option => option.id"
              v-model="direct_id"
            >
              <template #option="{ name, direct_id }">
                {{ name }}
                <br />
                <b>{{ direct_id }}</b>
              </template>
            </v-select>
          </div>
          <b-button
            class="navbarBtn-nap"
            variant="primary"
            v-b-modal="'nap-modal'"
            @click="getMed"
            >
            +
          </b-button>
          <b-modal
            :id="'nap-modal'"
            :title="$t('Напровитель')"
            hide-footer
          >
            <div>
              <div>
                  <div>
                      <span>
                          <span class="shirift">{{ $t("Ф.И.Ш") }}</span>
                          <span style="color: red;">*</span>
                          <span v-if="errorsNap !== null">
                          <span
                              style="color: red; font-size: 9px"
                              v-if="!errorsNap.name.required"
                              >{{ $t("Ф.И.Ш тўлдирилиши керак") }}</span
                          >
                          <span
                              style="color: red; font-size: 9px"
                              v-if="!errorsNap.name.minLength"
                              >{{ $t("Ф.И.Ш да камида 4 та белги бўлиши керак") }}</span
                          >
                          </span>
                      </span>
                      <b-input id="naprovitel-name" v-model="NapData.name" type="text" />

                  <span>
                      <span class="shirift">{{ $t("Вакил") }}</span>
                      <span style="color: red;">*</span>
                      <span v-if="errorsNap !== null">
                      <span
                          style="color: red; font-size: 9px"
                          v-if="!errorsNap.name.required"
                          >{{ $t("Ф.И.Ш тўлдирилиши керак") }}</span
                      >
                      </span>
                  </span>
                  <v-select
                      :options="MedPris"
                      label="name"
                      :reduce="option => option.id"
                      v-model="NapData.med_id"
                  />
                  </div>
                  <div>
                  <span>
                      <span class="shiri">
                      {{ $t("ID") }}
                      </span>
                      <span style="color: red;">*</span>
                      <span v-if="errorsNap !== null">
                      <span
                          style="color: red; font-size: 9px"
                          v-if="!errorsNap.direct_id.required"
                          >{{ $t("ID тўлдирилиши керак") }}</span
                      >
                      </span>
                  </span>
                  
                  <b-input
                      id="naprovitel-name"
                      v-model="NapData.direct_id"
                      type="number"
                  />
                  </div>
                  <div class="CreateName">
                  <b-button
                      class="modalBtn1"
                      size="sm"
                      style="height: 37px;"
                      variant="danger "
                      @click="close"
                  >
                      <b-icon icon="calendar2-x"></b-icon>
                      {{ $t("Бекор қилиш") }}
                  </b-button>
                  <b-button
                      class="mt-3 ml-2 modalBtn"
                      @click="Save"
                      variant="success"
                  >
                      <b-icon icon="calendar2-plus"></b-icon>
                      {{ $t("Сақлаш") }}
                  </b-button>
                  </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(itemShB, indB) in shifokor" :key="indB" class="tek-item">
        <div class="chek-teksh-div">
          <div class="chek-tek">
            {{ itemShB.name }}
          </div>
        </div>
        <div class="item-child">
          <div style="padding: 5px;">
            <table class="table table-sm table-bordered striped table-style">
              <tbody>
                <tr
                  v-for="(itemSh, indSh) in itemShB.bolim.doctor_category"
                  :key="indSh"
                  style="max-height: 30px;"
                  :class="{ bg: indSh % 2 == 1 }"
                >
                  <td>
                    <b-form-checkbox
                      @change="ChakkedType(itemSh, itemShB)"
                      v-model="itemSh.change"
                      style="display: flex;"
                      :value="true"
                      :unchecked-value="false"
                    >
                      {{ itemSh.name }}
                    </b-form-checkbox>
                  </td>
                  <td v-if="!shifKorigi">
                    <span v-if="$store.state.bemor.citizen">{{
                      itemSh.citizen_price | numFormat
                    }}</span>
                    <span v-else>{{ itemSh.price | numFormat }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import Fuse from "fuse.js";
export default {
  props: [
    "shifokor", 
    "index", 
    "shifKorigi",
    "Naprovitel"
  ],
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")),
      NapData: {
        direct_id: null,
        name: "",
        med_id: null,
        bonus_type: 1,
        bonus: 0
      },
      direct_id: null,
      Deselect: {
        render: createElement => createElement("span", "")
      },
      MedPris: [],
      bonus_type: [
        {id: 0, name: "Naqd"},
        {id: 1, name: "Foiz"},
      ],
      errorsNap: null,
    };
  },
  validations: {
    NapData: {
      name: {
        required,
        minLength: minLength(4)
      },
      direct_id: {
        required
      },
      med_id: {
        required
      }
    },
  },
  methods: {
    ChakkedType(item, itemShB) {
      if (this.$store.state.bemor.id) {
        this.$emit("itemSh", item, this.index, itemShB, this.direct_id);
      } else {
        this.$emit("itemSh", item, this.index, itemShB, this.direct_id);
        return (item.change = false);
      }
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ["name", "direct_id"],
        shouldSort: true
      });
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list;
    },
    getMed() {
      let s = this;
      axios({
          method: "get",
          url: "/med_direct/all"
      }).then(res => {
          if (res) {
          s.MedPris = res.data.data;
          }
      });
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ["name", "direct_id"],
        shouldSort: true
      });
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list;
    },
    Save(){
      let self = this;
      this.$v.$touch();
      if (this.$v.NapData.$error == false) {
        axios({
        method: "post",
        url: "/direct/create",
        data: self.NapData
        }).then(data => {
          if (data) {
            self.$bvModal.hide('nap-modal')
            this.$emit("naprovitel", data.data.data)
            // self.getNaprovitel()
            self.direct_id = data.data.data.id
            self.NapData = {
              direct_id: null,
              name: "",
              med_id: null,
              bonus: 0
            }
          }
        });
      } else {
        self.errorsNap = self.$v.NapData;
      }
    },
    close(){
      this.NapData = {
        direct_id: null,
        name: "",
        med_id: null,
        bonus: 0
      }
    },
  }
};
</script>
<style>
.tek-item {
  width: 530px;
  flex-wrap: wrap;
  margin: 5px;
  display: flex;
  padding: 5px;
  background: #f0f0f03d;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.bg {
  background: #abdfffd3;
}
.table-style {
  background: #fff;
}
.chek-teksh-div {
  display: flex;
  align-items: center;
  font-weight: 600;
  width: 100%;
}
.chek-tek {
  display: flex;
  padding: 3px 5px;
  border-radius: 5px;
  align-items: center;
  font-weight: 600;
  width: 100%;
  border: 1px solid rgb(46, 165, 255);
  font-size: 18px;
  background: rgba(7, 100, 172, 0.078);
  color: #3f51b5;
}
.tek-item {
  display: inline;
}
.item-child {
  border: 1px solid rgb(46, 165, 255);
  width: 100%;
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  margin-top: 5px;
  max-height: 470px;
}
</style>
